<template>
    <div class="section">
        <div class="section-heading-group">
            <h2 class="heading heading--no-margin">{{ header }}</h2>
            <span
                @click="toggleSection"
                v-if="!showOnlyWhenExpanded || isExpanded"
                class="show-all help-text"
            >
                {{ toggleText }}
            </span>
        </div>
        <task-list
            v-if="!showOnlyWhenExpanded || isExpanded"
            :limit-output="outputLimit"
            :tasks="tasks"
            @click-on-show-graph-icon="clickOnShowDrawIcon"
            @click-on-show-detailed-task-info-icon="clickOnShowDetailedTaskInfoIcon"
        />
<!--        <p v-if="(!showOnlyWhenExpanded || isExpanded) && tasks.length === 0">-->
<!--            Здесь пока ничего нет-->
<!--        </p>-->
<!--        <v-button-->
<!--            v-if="showOnlyWhenExpanded && !isExpanded"-->
<!--            @click="toggleSection"-->
<!--            label="Перейти в архив"-->
<!--        />-->
    </div>
</template>

<script>
import TaskList from './TaskList'
//import vButton from '../vButton'

export default {
  name: 'TaskListWrapper',
  components: {
    TaskList,
    //vButton
  },
  props: {
    header: {
      type: String,
      required: true
    },
    tasks: {
      type: Array,
      required: true
    },
    showOnlyWhenExpanded: {
      type: Boolean,
      default: false
    },
    isExpanded: {
      type: Boolean,
      default: false
    },
    outputLimitValue: {
      type: Number,
      default: 3
    }
  },
  computed: {
    toggleText() {
      if (this.isExpanded) {
        return 'назад'
      } else {
        return 'показать все'
      }
    },
    outputLimit() {
      return this.isExpanded ? undefined : this.outputLimitValue
    }
  },
  methods: {
    toggleSection() {
      this.$emit('toggled')
    },
    clickOnShowDrawIcon(payload) {
      this.$emit('click-on-show-graph-icon', payload)
    },
    clickOnShowDetailedTaskInfoIcon(task) {
      this.$emit('click-on-show-detailed-task-info-icon', task)
    },
  }
}
</script>

<style lang="sass" scoped>
    .section-heading-group
        display: flex
        align-items: center
        margin-bottom: gridSteps(4)

    .show-all
        margin-left: gridSteps(3)
        cursor: pointer

        &:hover
            text-decoration: underline
</style>
